var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeStatus0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8972 0H16.1028L0 16.6883V40.3117L16.1028 57H38.8972L55 40.3117V16.6883L38.8972 0ZM42.7778 40.3433L38.9278 44.3333L27.5 32.49L16.0722 44.3333L12.2222 40.3433L23.65 28.5L12.2222 16.6567L16.0722 12.6667L27.5 24.51L38.9278 12.6667L42.7778 16.6567L31.35 28.5L42.7778 40.3433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeStatus0);
export default __webpack_public_path__ + "static/media/charge-status0.5180d18c3315eb3247b1cd9f2d5b46b0.svg";
export { ForwardRef as ReactComponent };